import { atom } from 'recoil';
import { CustomerResponseData } from '../../TYPES/api.body';
import { STORE_KEYS } from '../keys';

export const profileAtom = atom<CustomerResponseData | undefined>({
  key: STORE_KEYS.USER_PROFILE,
  default: undefined
});
